import * as Yup from 'yup'

export type TSchema = {
  name: string
  lastName: string
  email: string
  birthday: string
  hometown: string
  celular: string
  cpf: string
  crm: string
  ufCrm: string
  password: string
  anotherSpeciality?: string
  sex: string
  serviceAvailability: Array<Record<string, unknown>>
  preferenceForAttendance?: string
}

export const getSchema = (
  hasPreferenceForAttendance: boolean,
): Yup.SchemaOf<TSchema> => {
  const schema: Yup.SchemaOf<TSchema> = Yup.object()
    .shape({
      name: Yup.string()
        .min(2, 'Este campo deve possuir ao menos 2 caracteres')
        .max(60, 'Este campo não pode possuir mais de 60 caracteres')
        .required('campo obrigatório'),
      lastName: Yup.string()
        .min(2, 'Este campo deve possuir ao menos 2 caracteres')
        .max(60, 'Este campo não pode possuir mais de 60 caracteres')
        .required('campo obrigatório'),
      email: Yup.string()
        .min(2, 'Este campo deve possuir ao menos 2 caracteres')
        .max(60, 'Este campo não pode possuir mais de 60 caracteres')
        .email('Email inválido')
        .required('campo obrigatório'),
      birthday: Yup.mixed().required('campo obrigatório'),
      hometown: Yup.string()
        .min(2, 'Este campo deve possuir ao menos 2 caracteres')
        .max(50, 'Este campo não pode possuir mais de 50 caracteres')
        .required('campo obrigatório'),
      celular: Yup.string()
        .matches(
          /^\([1-9]{2}\) [9]{0,1}[2-9]{1}[0-9]{3}-[0-9]{4}$/,
          'Celular inválido',
        )
        .required('campo obrigatório'),
      cpf: Yup.string()
        .matches(/[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}-?[0-9]{2}/, 'Cpf inválido')
        .required('campo obrigatório'),
      crm: Yup.string()
        .min(2, 'Este campo deve possuir ao menos 2 caracteres')
        .max(20, 'Este campo não pode possuir mais de 20 caracteres')
        .required('campo obrigatório'),
      ufCrm: Yup.string().required('campo obrigatório'),
      password: Yup.string()
        .min(8, 'Este campo deve possuir ao menos 8 caracteres')
        .max(20, 'Este campo não pode possuir mais de 20 caracteres')
        .required('campo obrigatório'),
      anotherSpeciality: Yup.string().max(
        20,
        'Este campo não pode possuir mais de 20 caracteres',
      ),
      sex: Yup.string().required('campo obrigatório'),
      serviceAvailability: Yup.array().test({
        message: 'campo obrigatório',
        test: arr => arr.length > 0,
      }),
      ...(!hasPreferenceForAttendance && {
        preferenceForAttendance: Yup.string().required('campo obrigatório'),
      }),
      ...(hasPreferenceForAttendance && {
        speciality: Yup.string().required('campo obrigatório'),
      }),
    })
    .required()

  return schema
}
